/**
 * Shared pricing hook — the single source of truth on the frontend for every
 * page that displays plan / pack / smart-report prices. Backed by
 * `GET /api/public/platform-settings` which returns the projection
 * built in `routers/pricing.py::public_pricing_projection`.
 *
 * Any component using this hook automatically reflects Super Admin edits
 * without further plumbing.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
let _inFlight = null;

async function fetchPricing() {
  if (_cache) return _cache;
  if (_inFlight) return _inFlight;
  _inFlight = api
    .get("/public/platform-settings")
    .then((r) => {
      _cache = r.data?.pricing || null;
      return _cache;
    })
    .finally(() => { _inFlight = null; });
  return _inFlight;
}

export function usePublicPricing() {
  const [pricing, setPricing] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);
  useEffect(() => {
    let alive = true;
    fetchPricing()
      .then((p) => { if (alive) setPricing(p); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { pricing, loading };
}

export function currencySymbol(pricing) {
  return pricing?.currency?.symbol || "₹";
}
